import { createSelector } from 'reselect';
import { columns } from '../../constants/data';

const getCurrentSite = state => state.sites.currentSite;

/**
  @name getMapViewColumns
  Selector to obtain the map view columns config with custom headers
*/
const getMapViewColumns = createSelector(
  [getCurrentSite], (currentSite) => {
      
      // Set custom headers if available
      columns.forEach(column => {
        if (column.customLabelKey) {
          column.Header = currentSite.labels && currentSite.labels[column.customLabelKey] ? 
            currentSite.labels[column.customLabelKey] : column.defaultHeader;
        } 
      })

      return columns;
  }
);

export default getMapViewColumns;



// WEBPACK FOOTER //
// ./src/utils/selectors/getMapViewColumns.js